import { ChangeDetectionStrategy, Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { getWindow } from 'ssr-window';

const win = getWindow();
@Component({
  selector: 'app-image-animation',
  templateUrl: './image-animation.component.html',
  styleUrls: ['./image-animation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageAnimationComponent implements OnInit, OnDestroy {
  @Input() imagePath = '';
  @Input() altText = '';
  constructor(private el: ElementRef){
  }

  boundedSetClass = this.setClass.bind(this);

  ngOnInit() {
    win.addEventListener('scroll', this.boundedSetClass);
    this.boundedSetClass();
  }

  setClass() {
    const bounding = this.el.nativeElement.getBoundingClientRect();
    if (bounding.top >= 0 && bounding.bottom <= window.innerHeight) {
      // Add a class to animate coffee-cup
      this.el.nativeElement.classList.add('image-fade');
      win.removeEventListener('scroll', this.boundedSetClass);
    }
  }

  ngOnDestroy() {
    win.removeEventListener('scroll', this.boundedSetClass);
  }
}
